var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('kt-panel',[_c('kt-panel-body',[(_vm.status !== 'loading')?_c('store-form',{attrs:{"submit":_vm.updateStore,"query":_vm.store}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }